<template>
<div class="card">
  <div class="card-header">
    <h4 class="card-title"><i class="ti-camera"></i> Foto </h4>
  </div>

  <div class="card-content">
    <div class="row">
      <div class="col-md-12 text-center">
        <webcam
          v-if="!img"
          ref="webcam"
          :width="640"
          :height="480"
          screenshotFormat="image/jpeg"
        />
        <img
          v-if="img"
          class="img-thumbnail img-capture"
          :src="this.img"
        />
      </div>
    </div>
  </div>

  <div class="card-footer text-center">
    <button
      v-if="!img"
      @click.prevent="handleImageCapture()"
      class="btn btn-fill btn-primary btn-wd"
    >
      <i class="ti-camera"></i>
      Salvar Imagem
    </button>
    <button
      @click="$refs['imgFile'].click()"
      class="btn btn-fill btn-primary btn-wd"
    >
      <input
        id="imgFile"
        ref="imgFile"
        @change="selectImage"
        style="display: none"
        type="file"
        accept="image/*"
      />Upload Imagem
    </button>
    <button
      v-if="img"
      @click.prevent="handleAcceptImage()"
      :disabled="unabled"
      class="btn btn-fill btn-success btn-wd"
    >
      <i class="ti-check"></i>
      Aceitar
    </button>

    <button
      v-if="img"
      @click.prevent="handleRefuseImage()"
      class="btn btn-fill btn-danger btn-wd"
    >
      <i class="ti-close"></i>
      Recusar
    </button>
  </div>

</div>
</template>
<script>
import Webcam from 'components/Webcam'
import { filesService } from '../../services/filesService'

export default {
  name: 'CustomerImageCapture',
  components: {
    Webcam
  },
  props: {
    screenshotFormat: {
      type: String,
      default: 'image/jpeg'
    }
  },
  data () {
    return {
      img: null,
      unabled: false,
      capture: true
    }
  },

  methods: {
    handleImageCapture () {
      this.unabled = false
      this.img = this.$refs.webcam.capture()
    },
    async selectImage (event) {
      try {
        const type = event.target.files[0].type
        const file = await this.handleFile(event, type)
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onloadend = () => {
          this.img = reader.result
          this.capture = false
        }
      } catch (e) {
        console.log('err', e)
      }
    },
    handleFile (event, type) {
      return new Promise(resolve => {
        resolve(filesService.handleBlob(event, type))
      })
    },
    uploadImage () {
      this.unabled = false
    },
    handleAcceptImage () {
      this.unabled = true
      this.$emit('on-image-captured', { image: this.img })
    },
    handleRefuseImage () {
      this.img = null
    }
  }
}
</script>
<style>
  .img-capture {
    width: 640px;
    height: 480px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Customers/CustomerImageCapture.vue